import { observer } from 'mobx-react'
import './completedSurveys.scss'
import React, { Component } from 'react'
import * as R from 'ramda'
import Panel from '../../../../UniformComponents/Panel'
import ExploriDatePicker from '../../../ExploriDatePicker'
import Button from '../../../../UniformComponents/Button'
import CompletedSurveysStore from './CompletedSurveysStore'
import Typography from '../../../../UniformComponents/Typography'
import Select from '../../../form/Select'

@observer
class SystemCompletedSurveys extends Component {
    constructor(props) {
        super(props)
        const { store } = props
        this.compltedSurveyStore = new CompletedSurveysStore(store)
    }

    componentDidMount() {
        const { store } = this.props
        this.compltedSurveyStore.getProductMap()
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'systemCompletedSurveys',
                url: '/intranet/systemCompletedSurveys',
                title: 'System Completed Surveys',
            },
        ]
    }

    renderFilters = () => {
        const {
            handleCompletedSurveyRequest,
            selectTypes,
            getSystemCompletedSyrveys,
            completedSurveyRequest,
        } = this.compltedSurveyStore
        const { store } = this.props
        const { startDate, endDate } = completedSurveyRequest
        return (
            <div className="select">
                {
                    selectTypes.map((type) => (
                        <div className="formItems">
                            <Select
                                label={type.label}
                                options={this.compltedSurveyStore.options[type.name]}
                                onChange={(e) => handleCompletedSurveyRequest(e, type.name)}
                                value={completedSurveyRequest[type.value]
                                    ? this.compltedSurveyStore.options[type.name]
                                        .find((option) => option.value === completedSurveyRequest[type.value]) : ''}
                            />

                            <br />
                        </div>
                    ))
                }
                <div className="formItems">
                    <label>From:</label>
                    <ExploriDatePicker onChange={(e) => handleCompletedSurveyRequest(e, 'start')} dateOnly placeholder={startDate} dateTimeFormat="yyyy-MM-DD" />
                </div>
                <div className="formItems">
                    <label>Select To:</label>
                    <ExploriDatePicker onChange={(e) => handleCompletedSurveyRequest(e, 'end')} dateOnly placeholder={endDate} dateTimeFormat="yyyy-MM-DD" />
                </div>

                <div className="filterButton">
                    <Button
                        label="GO"
                        cssClass="regular primary"
                        onClick={() => getSystemCompletedSyrveys()}
                        style={{ textAlign: 'center', width: 'inherit' }}
                    />
                </div>

            </div>
        )
    }

    renderResults = () => {
        const { completedSurveyResponse } = this.compltedSurveyStore
        const { completed, started } = completedSurveyResponse
        return (
            <div className="select results">
                <div>
                    <p>{`${completed} Completed`}</p>
                </div>
                <div>
                    <p>{`${started} Started`}</p>
                </div>
            </div>
        )
    }

    render() {
        const { completedSurveyResponse } = this.compltedSurveyStore
        const { completed, started } = completedSurveyResponse
        return (
            <Panel id="SystemCompletedSurveys" cssClass="parent">
                <div className="center">
                    <Typography type="h2">System Completed Surveys</Typography>

                    <br />

                    <Typography>
                        Please be aware that this can take a while
                    </Typography>
                </div>
                {this.renderFilters()}
                {!R.isNil(completed) && !R.isNil(started) ? this.renderResults() : null}
            </Panel>

        )
    }
}
export default SystemCompletedSurveys
